import { useEffect } from 'react'
import { createPortal } from 'react-dom'

import { fehlertext } from '../../api/client'
import { useEscape } from '../../hooks/useEscape'
import { veilCloses } from '../../lib/veil'
import { useTagestrenner } from '../../hooks/queries'
import { trennerTag } from '../../lib/ortszeit'
import { useTexte } from '../../texte'
import { Blattkopf } from '../../components/Blattkopf'

/**
 * The days of the trip (#113, 1.85.0): every day separator in the order of
 * the days (1.86.0; newest first until then), one tap each -- behind the
 * calendar in the pill.
 *
 * Built like `Tageswahl`: a sheet on `document.body`, the server decides
 * which separators there are (every one went through `Visibility` with the
 * post it hangs on), and a tap hands the post's id to the caller, which
 * jumps there the way it jumps from a search hit (`?m=`).
 */
export function Tagestrennerliste({
  tripId,
  onWahl,
  onSchliessen,
}: {
  tripId: number
  onWahl: (messageId: number) => void
  onSchliessen: () => void
}) {
  const texte = useTexte()
  const t = texte.chat.tagestrenner
  const liste = useTagestrenner(tripId, true)

  useEscape(onSchliessen)
  useEffect(() => {
    const feld = document.activeElement
    if (feld instanceof HTMLElement) feld.blur()
  }, [])

  return createPortal(
    <div className="bogen bogen--obenauf bogen--schliesst" role="dialog" aria-modal="true" aria-label={t.listeTitel} data-tagestrennerliste="" onClick={veilCloses(onSchliessen)}>
      <div className="bogen__blatt bogen__blatt--gegliedert">
        <Blattkopf titel={t.listeTitel} onSchliessen={onSchliessen} />
        <div className="bogen__rolle">
          {liste.isError ? (
            <p className="bogen__problem" role="alert">{fehlertext(liste.error)}</p>
          ) : liste.data === undefined ? (
            <p className="bogen__hinweis">{texte.allgemein.laeuft}</p>
          ) : liste.data.separators.length === 0 ? (
            <p className="bogen__hinweis">{t.listeLeer}</p>
          ) : (
            <ul className="tageswahl__liste">
              {liste.data.separators.map((trenner) => {
                const { datum, wochentag } = trennerTag(trenner.day)
                return (
                  <li key={trenner.message_id}>
                    <button
                      type="button"
                      className="tageswahl__zeile tageswahl__zeile--trenner"
                      data-tag={trenner.day}
                      data-nachricht={trenner.message_id}
                      onClick={() => onWahl(trenner.message_id)}
                    >
                      <span>{t.listeZeile(t.zaehler(trenner.word, trenner.number), wochentag, datum)}</span>
                      {trenner.note !== '' && <span className="tageswahl__anzahl">{trenner.note}</span>}
                    </button>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      </div>
    </div>,
    document.body,
  )
}
